/* eslint-disable */
/* THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Regenerate via src/api/scripts/generator.sh */
/* generator-hash: 40983a676bd222ccbe47300b720bb6048431338b17b8d3a694eb64b12e21ffe8 */
import { emptySplitApi as api } from '../emptyApi'
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getBulletins: build.query<GetBulletinsApiResponse, GetBulletinsApiArg>({
      query: (queryArg) => ({
        url: `/bulletinboard/bulletins`,
        headers: {},
        params: {
          clientId: queryArg.clientId,
          includeCancelled: queryArg.includeCancelled,
        },
      }),
    }),
    getBulletinsByBulletinId: build.query<
      GetBulletinsByBulletinIdApiResponse,
      GetBulletinsByBulletinIdApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/bulletins/${queryArg.bulletinId}`,
        headers: {},
      }),
    }),
    putBulletinsByBulletinIdSetread: build.mutation<
      PutBulletinsByBulletinIdSetreadApiResponse,
      PutBulletinsByBulletinIdSetreadApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/bulletins/${queryArg.bulletinId}/setread`,
        method: 'PUT',
        headers: {},
      }),
    }),
    putBulletinsByBulletinIdSetunread: build.mutation<
      PutBulletinsByBulletinIdSetunreadApiResponse,
      PutBulletinsByBulletinIdSetunreadApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/bulletins/${queryArg.bulletinId}/setunread`,
        method: 'PUT',
        headers: {},
      }),
    }),
    getBulletinsByBulletinIdAttachmentsAndAttachmentId: build.query<
      GetBulletinsByBulletinIdAttachmentsAndAttachmentIdApiResponse,
      GetBulletinsByBulletinIdAttachmentsAndAttachmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/bulletins/${queryArg.bulletinId}/attachments/${queryArg.attachmentId}`,
        headers: {},
      }),
    }),
    getBulletinsByBulletinIdEvent: build.query<
      GetBulletinsByBulletinIdEventApiResponse,
      GetBulletinsByBulletinIdEventApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/bulletins/${queryArg.bulletinId}/event`,
        headers: {},
      }),
    }),
    postMaintenanceBulletinsList: build.query<
      PostMaintenanceBulletinsListApiResponse,
      PostMaintenanceBulletinsListApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/bulletins/query`,
        method: 'POST',
        body: queryArg.bulletinBoardQueryRequestModel,
        headers: {},
      }),
    }),
    postMaintenanceBulletins: build.mutation<
      PostMaintenanceBulletinsApiResponse,
      PostMaintenanceBulletinsApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/bulletins`,
        method: 'POST',
        body: queryArg.bulletinBoardNewRequest,
        headers: {},
      }),
    }),
    getMaintenanceBulletinsByBulletinId: build.query<
      GetMaintenanceBulletinsByBulletinIdApiResponse,
      GetMaintenanceBulletinsByBulletinIdApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/bulletins/${queryArg.bulletinId}`,
        headers: {},
      }),
    }),
    putMaintenanceBulletinsByBulletinId: build.mutation<
      PutMaintenanceBulletinsByBulletinIdApiResponse,
      PutMaintenanceBulletinsByBulletinIdApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/bulletins/${queryArg.bulletinId}`,
        method: 'PUT',
        body: queryArg.bulletinBoardUpdateRequest,
        headers: {},
      }),
    }),
    deleteMaintenanceBulletinsByBulletinId: build.mutation<
      DeleteMaintenanceBulletinsByBulletinIdApiResponse,
      DeleteMaintenanceBulletinsByBulletinIdApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/bulletins/${queryArg.bulletinId}`,
        method: 'DELETE',
        headers: {},
      }),
    }),
    postMaintenanceBulletinsByBulletinIdImage: build.mutation<
      PostMaintenanceBulletinsByBulletinIdImageApiResponse,
      PostMaintenanceBulletinsByBulletinIdImageApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/bulletins/${queryArg.bulletinId}/image`,
        method: 'POST',
        body: queryArg.body,
        headers: {},
      }),
    }),
    deleteMaintenanceBulletinsByBulletinIdImage: build.mutation<
      DeleteMaintenanceBulletinsByBulletinIdImageApiResponse,
      DeleteMaintenanceBulletinsByBulletinIdImageApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/bulletins/${queryArg.bulletinId}/image`,
        method: 'DELETE',
        headers: {},
      }),
    }),
    getMaintenanceBulletinsByBulletinIdEvent: build.query<
      GetMaintenanceBulletinsByBulletinIdEventApiResponse,
      GetMaintenanceBulletinsByBulletinIdEventApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/bulletins/${queryArg.bulletinId}/event`,
        headers: {},
      }),
    }),
    getMaintenanceBulletinsByBulletinIdReadstatusSummary: build.query<
      GetMaintenanceBulletinsByBulletinIdReadstatusSummaryApiResponse,
      GetMaintenanceBulletinsByBulletinIdReadstatusSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/bulletins/${queryArg.bulletinId}/readstatus/summary`,
        headers: {},
      }),
    }),
    getMaintenanceBulletinsByBulletinIdReadstatusDetails: build.query<
      GetMaintenanceBulletinsByBulletinIdReadstatusDetailsApiResponse,
      GetMaintenanceBulletinsByBulletinIdReadstatusDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/bulletins/${queryArg.bulletinId}/readstatus/details`,
        headers: {},
      }),
    }),
    getMaintenanceBulletinsByBulletinIdAlerts: build.query<
      GetMaintenanceBulletinsByBulletinIdAlertsApiResponse,
      GetMaintenanceBulletinsByBulletinIdAlertsApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/bulletins/${queryArg.bulletinId}/alerts`,
        headers: {},
      }),
    }),
    postMaintenanceBulletinsByBulletinIdAlerts: build.mutation<
      PostMaintenanceBulletinsByBulletinIdAlertsApiResponse,
      PostMaintenanceBulletinsByBulletinIdAlertsApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/bulletins/${queryArg.bulletinId}/alerts`,
        method: 'POST',
        body: queryArg.body,
        headers: {},
      }),
    }),
    deleteMaintenanceBulletinsByBulletinIdAlerts: build.mutation<
      DeleteMaintenanceBulletinsByBulletinIdAlertsApiResponse,
      DeleteMaintenanceBulletinsByBulletinIdAlertsApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/bulletins/${queryArg.bulletinId}/alerts`,
        method: 'DELETE',
        headers: {},
      }),
    }),
    postMaintenanceBulletinsByBulletinIdAttachments: build.mutation<
      PostMaintenanceBulletinsByBulletinIdAttachmentsApiResponse,
      PostMaintenanceBulletinsByBulletinIdAttachmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/bulletins/${queryArg.bulletinId}/attachments`,
        method: 'POST',
        body: queryArg.body,
        headers: {},
      }),
    }),
    getMaintenanceAttachmentsByAttachmentId: build.query<
      GetMaintenanceAttachmentsByAttachmentIdApiResponse,
      GetMaintenanceAttachmentsByAttachmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/attachments/${queryArg.attachmentId}`,
        headers: {},
      }),
    }),
    deleteMaintenanceAttachmentsByAttachmentId: build.mutation<
      DeleteMaintenanceAttachmentsByAttachmentIdApiResponse,
      DeleteMaintenanceAttachmentsByAttachmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/attachments/${queryArg.attachmentId}`,
        method: 'DELETE',
        headers: {},
      }),
    }),
    getMaintenanceAlerts: build.query<
      GetMaintenanceAlertsApiResponse,
      GetMaintenanceAlertsApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/clients/${queryArg.clientId ?? ':clientId'}/alerts`,
        headers: {},
      }),
    }),
    postMaintenanceByBulletinIdNotificationsResend: build.mutation<
      PostMaintenanceByBulletinIdNotificationsResendApiResponse,
      PostMaintenanceByBulletinIdNotificationsResendApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/${queryArg.bulletinId}/notifications/resend`,
        method: 'POST',
        headers: {},
      }),
    }),
    putMaintenanceByBulletinIdPinned: build.mutation<
      PutMaintenanceByBulletinIdPinnedApiResponse,
      PutMaintenanceByBulletinIdPinnedApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/${queryArg.bulletinId}/pinned`,
        method: 'PUT',
        body: queryArg.bulletinBoardPinnedUpdateRequest,
        headers: {},
      }),
    }),
    postBulletinsByBulletinIdComments: build.mutation<
      PostBulletinsByBulletinIdCommentsApiResponse,
      PostBulletinsByBulletinIdCommentsApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/bulletins/${queryArg.bulletinId}/comments`,
        method: 'POST',
        body: queryArg.commentInsertModel,
        headers: {},
      }),
    }),
    getBulletinsByBulletinIdComments: build.query<
      GetBulletinsByBulletinIdCommentsApiResponse,
      GetBulletinsByBulletinIdCommentsApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/bulletins/${queryArg.bulletinId}/comments`,
        headers: {},
      }),
    }),
    putBulletinsByBulletinIdCommentsAndCommentId: build.mutation<
      PutBulletinsByBulletinIdCommentsAndCommentIdApiResponse,
      PutBulletinsByBulletinIdCommentsAndCommentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/bulletins/${queryArg.bulletinId}/comments/${queryArg.commentId}`,
        method: 'PUT',
        body: queryArg.commentUpdateModel,
        headers: {},
      }),
    }),
    deleteBulletinsByBulletinIdCommentsAndCommentId: build.mutation<
      DeleteBulletinsByBulletinIdCommentsAndCommentIdApiResponse,
      DeleteBulletinsByBulletinIdCommentsAndCommentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/bulletins/${queryArg.bulletinId}/comments/${queryArg.commentId}`,
        method: 'DELETE',
        headers: {},
      }),
    }),
    postMaintenanceBulletinsByBulletinIdAttachmentsboardarchive: build.mutation<
      PostMaintenanceBulletinsByBulletinIdAttachmentsboardarchiveApiResponse,
      PostMaintenanceBulletinsByBulletinIdAttachmentsboardarchiveApiArg
    >({
      query: (queryArg) => ({
        url: `/bulletinboard/maintenance/bulletins/${queryArg.bulletinId}/attachmentsboardarchive`,
        method: 'POST',
        body: queryArg.body,
        headers: {},
      }),
    }),
  }),
  overrideExisting: false,
})
export { injectedRtkApi as bulletinboard }
export type GetBulletinsApiResponse = /** status 200 OK */ BulletinModel[]
export type GetBulletinsApiArg = {
  /** The ID of the client to retrieve bulletins for. */
  clientId?: string
  /** Set to true to include cancelled buleltins */
  includeCancelled?: boolean
}
export type GetBulletinsByBulletinIdApiResponse =
  /** status 200 OK */ BulletinModel[]
export type GetBulletinsByBulletinIdApiArg = {
  /** The ID of the bulletin to retrieve. */
  bulletinId: string
}
export type PutBulletinsByBulletinIdSetreadApiResponse =
  /** status 200 OK */ string
export type PutBulletinsByBulletinIdSetreadApiArg = {
  /** Id of bulletin to set as read */
  bulletinId: string
}
export type PutBulletinsByBulletinIdSetunreadApiResponse =
  /** status 200 OK */ string
export type PutBulletinsByBulletinIdSetunreadApiArg = {
  /** Id of bulletin */
  bulletinId: string
}
export type GetBulletinsByBulletinIdAttachmentsAndAttachmentIdApiResponse =
  /** status 200 OK */ Blob
export type GetBulletinsByBulletinIdAttachmentsAndAttachmentIdApiArg = {
  /** The ID of the bulletin. */
  bulletinId: string
  /** The ID of the attachment to download. */
  attachmentId: string
}
export type GetBulletinsByBulletinIdEventApiResponse = /** status 200 OK */ Blob
export type GetBulletinsByBulletinIdEventApiArg = {
  /** Id of bulletin */
  bulletinId: string
}
export type PostMaintenanceBulletinsListApiResponse =
  /** status 200 OK */ BulletinBoardQueryResultRead
export type PostMaintenanceBulletinsListApiArg = {
  /** Query model */
  bulletinBoardQueryRequestModel: BulletinBoardQueryRequestModel
}
export type PostMaintenanceBulletinsApiResponse = /** status 200 OK */ string
export type PostMaintenanceBulletinsApiArg = {
  /** Bulletin data */
  bulletinBoardNewRequest: BulletinBoardNewRequest
}
export type GetMaintenanceBulletinsByBulletinIdApiResponse =
  /** status 200 OK */ BulletinBoardDetailsResponseRead
export type GetMaintenanceBulletinsByBulletinIdApiArg = {
  /** The ID of the bulletin to retrieve. */
  bulletinId: string
}
export type PutMaintenanceBulletinsByBulletinIdApiResponse = unknown
export type PutMaintenanceBulletinsByBulletinIdApiArg = {
  bulletinId: string
  bulletinBoardUpdateRequest: BulletinBoardUpdateRequest
}
export type DeleteMaintenanceBulletinsByBulletinIdApiResponse = unknown
export type DeleteMaintenanceBulletinsByBulletinIdApiArg = {
  /** The ID of the bulletin to delete. */
  bulletinId: string
}
export type PostMaintenanceBulletinsByBulletinIdImageApiResponse =
  /** status 200 OK */ string
export type PostMaintenanceBulletinsByBulletinIdImageApiArg = {
  /** The ID of the bulletin to delete. */
  bulletinId: string
  body: {
    file?: Blob
  }
}
export type DeleteMaintenanceBulletinsByBulletinIdImageApiResponse = unknown
export type DeleteMaintenanceBulletinsByBulletinIdImageApiArg = {
  /** Bulletin ID to delete image from. */
  bulletinId: string
}
export type GetMaintenanceBulletinsByBulletinIdEventApiResponse =
  /** status 200 OK */ Blob
export type GetMaintenanceBulletinsByBulletinIdEventApiArg = {
  /** Id of bulletin */
  bulletinId: string
}
export type GetMaintenanceBulletinsByBulletinIdReadstatusSummaryApiResponse =
  /** status 200 OK */ BulletinBoardReadStatusSummary
export type GetMaintenanceBulletinsByBulletinIdReadstatusSummaryApiArg = {
  /** Id of bulletin to retrieve read status summary */
  bulletinId: string
}
export type GetMaintenanceBulletinsByBulletinIdReadstatusDetailsApiResponse =
  /** status 200 OK */ BulletinBoardReadStatusDetails
export type GetMaintenanceBulletinsByBulletinIdReadstatusDetailsApiArg = {
  /** Id of bulletin to retrieve read status summary */
  bulletinId: string
}
export type GetMaintenanceBulletinsByBulletinIdAlertsApiResponse =
  /** status 200 OK */ AlertModelSelection[]
export type GetMaintenanceBulletinsByBulletinIdAlertsApiArg = {
  /** Id of bulletin ro retrieve alertgroups for */
  bulletinId: string
}
export type PostMaintenanceBulletinsByBulletinIdAlertsApiResponse = unknown
export type PostMaintenanceBulletinsByBulletinIdAlertsApiArg = {
  /** Id of bulletin to updatet alertgroups for. */
  bulletinId: string
  /** The updated alertgroup data */
  body: AlertModelSelection[]
}
export type DeleteMaintenanceBulletinsByBulletinIdAlertsApiResponse = unknown
export type DeleteMaintenanceBulletinsByBulletinIdAlertsApiArg = {
  /** Id of bulletin to dedlete alerts from */
  bulletinId: string
}
export type PostMaintenanceBulletinsByBulletinIdAttachmentsApiResponse = unknown
export type PostMaintenanceBulletinsByBulletinIdAttachmentsApiArg = {
  /** Id of bulletin add attachment for */
  bulletinId: string
  body: {
    files?: any
  }
}
export type GetMaintenanceAttachmentsByAttachmentIdApiResponse =
  /** status 200 OK */ Blob
export type GetMaintenanceAttachmentsByAttachmentIdApiArg = {
  /** Attachment id to download */
  attachmentId: string
}
export type DeleteMaintenanceAttachmentsByAttachmentIdApiResponse = unknown
export type DeleteMaintenanceAttachmentsByAttachmentIdApiArg = {
  /** Id of attachment to delete. */
  attachmentId: string
}
export type GetMaintenanceAlertsApiResponse = /** status 200 OK */ AlertModel[]
export type GetMaintenanceAlertsApiArg = {
  /** Id of client to retrieve alertgroups for */
  clientId?: string
}
export type PostMaintenanceByBulletinIdNotificationsResendApiResponse = unknown
export type PostMaintenanceByBulletinIdNotificationsResendApiArg = {
  /** Id of bulletin that users should be re-notified */
  bulletinId: string
}
export type PutMaintenanceByBulletinIdPinnedApiResponse = unknown
export type PutMaintenanceByBulletinIdPinnedApiArg = {
  /** Id of bulletin to be pinned */
  bulletinId: string
  /** Update pinned data */
  bulletinBoardPinnedUpdateRequest: BulletinBoardPinnedUpdateRequest
}
export type PostBulletinsByBulletinIdCommentsApiResponse =
  /** status 200 OK */ string
export type PostBulletinsByBulletinIdCommentsApiArg = {
  /** Id of the bulletin */
  bulletinId: string
  /** Comment data */
  commentInsertModel: CommentInsertModel
}
export type GetBulletinsByBulletinIdCommentsApiResponse =
  /** status 200 OK */ CommentModelRead[]
export type GetBulletinsByBulletinIdCommentsApiArg = {
  /** Id of bulletin */
  bulletinId: string
}
export type PutBulletinsByBulletinIdCommentsAndCommentIdApiResponse = unknown
export type PutBulletinsByBulletinIdCommentsAndCommentIdApiArg = {
  /** Id of bulletin */
  bulletinId: string
  /** Comment Id */
  commentId: string
  /** Comment update data */
  commentUpdateModel: CommentUpdateModel
}
export type DeleteBulletinsByBulletinIdCommentsAndCommentIdApiResponse = unknown
export type DeleteBulletinsByBulletinIdCommentsAndCommentIdApiArg = {
  /** Id of bulletin that the comment is connected to */
  bulletinId: string
  /** Id of comment to be deleted */
  commentId: string
}
export type PostMaintenanceBulletinsByBulletinIdAttachmentsboardarchiveApiResponse =
  unknown
export type PostMaintenanceBulletinsByBulletinIdAttachmentsboardarchiveApiArg =
  {
    /** Id of bulletin add attachment for */
    bulletinId: string
    /** List of documaster document ids */
    body: string[]
  }
export type BulletinAttachmentInfoModel = {
  /** Attachment id */
  id?: string | null
  /** Id of the bulletin the attachment is connected to */
  bulletinId?: string | null
  /** Filename */
  filename?: string | null
  /** The sequence number of theattachment */
  sequence?: number | null
  /** Created datetime */
  created?: string
  /** Type of document */
  mimetype?: string | null
  /** Description */
  description?: string | null
}
export type BulletinModel = {
  /** Unique identifier for the bulletin */
  id?: string | null
  /** Client identifier for the client the bulletin belongs to */
  clientId?: string | null
  /** Active from date for the bulletin. Used to displaying bulletin from this date. */
  activeFromDate?: string
  /** Active to date for the bulletin. Used to stop displaying bulletin after this date. */
  activeToDate?: string | null
  /** If the bulletin has a calendar event, this field specifies the start date of the calendar event */
  eventStart?: string | null
  /** If the bulletin has a calendar event, this field specifies the end date of the calendar event */
  eventEnd?: string | null
  /** Title of calendar event */
  eventTitle?: string | null
  /** Location of calendar event */
  eventLocation?: string | null
  /** Date when the bulletin was last updated */
  updatedDate?: string | null
  /** True if bulletin has been read */
  isRead?: boolean
  /** True if bulletin is active */
  isActive?: boolean
  /** True if bulletin is withdrawn */
  isCancelled?: boolean
  /** Title of bulletin */
  title?: string | null
  /** Text content of bulletin */
  bodyText?: string | null
  /** Html content of bulletin */
  bodyHtml?: string | null
  /** Created date of the bulletin */
  createdDate?: string
  /** NameregisterId of creator of bulletin */
  createdByNameId?: string | null
  /** NameregisterId of the user who last updated the bulletin */
  updatedByNameId?: string | null
  /** Name of user who created the bulletin */
  createdBy?: string | null
  /** Name of user who last updated the bulletin */
  updatedBy?: string | null
  /** True if bulletin is enabled for comments */
  areCommentsEnabled?: boolean
  /** List of attachment metadata for bulletin */
  attachments?: BulletinAttachmentInfoModel[] | null
  /** Url of bulletin image */
  imageUrl?: string | null
  /** Count of comments on bulletin */
  commentsCount?: number
  /** True if bulletin has been pinned for display on top of the list */
  pinned?: boolean
  publishedByApplication?: BulletinPublishedByApplication
}
export type ProblemDetails = {
  type?: string | null
  title?: string | null
  status?: number | null
  detail?: string | null
  instance?: string | null
  [key: string]: any
}
export type PeriodModel = {
  /** The start date and time of the period. */
  from?: string
  /** The end date and time of the period. */
  to?: string
}
export type EventModel = {
  period?: PeriodModel
  /** The title or name of the calendar event. */
  title?: string | null
  /** The location where the calendar event is held. */
  location?: string | null
}
export type BulletinBoardQueryResponse = {
  /** Unique identifier for the bulletin. */
  id?: string | null
  /** Identifier for the client to which the bulletin belongs. */
  clientId?: string | null
  activePeriod?: PeriodModel
  event?: EventModel
  /** The date and time when the bulletin was last updated, or null if never updated. */
  updatedDate?: string | null
  status?: BulletinBoardStatus
  /** Indicates whether the bulletin is currently active. */
  isActive?: boolean
  /** Indicates whether the bulletin has been withdrawn. */
  isWithdrawn?: boolean
  /** Indicates whether the bulletin is historic (i.e., its active period has ended). */
  isHistoric?: boolean
  /** The title of the bulletin. */
  title?: string | null
  /** The date and time when the bulletin was created. */
  createdDate?: string
  /** The name identifier of the user who created the bulletin. */
  createdByNameId?: string | null
  /** The display name of the user who created the bulletin. */
  createdBy?: string | null
  /** The name identifier of the user who last updated the bulletin. */
  updatedByNameId?: string | null
  /** The display name of the user who last updated the bulletin. */
  updatedBy?: string | null
  /** The date and time when the bulletin was withdrawn, or null if not withdrawn. */
  withdrawnDate?: string | null
  /** The URL of the image associated with the bulletin. */
  imageUrl?: string | null
  /** True to enable user comments for this bulletin while it is visible on My Page; false to disable comments. */
  areCommentsEnabled?: boolean
  /** The number of comments on the bulletin. */
  commentsCount?: number
  /** Indicates if the bulletin has been pinned for display at the top of the list. */
  pinned?: number
  publishedByApplication?: BulletinPublishedByApplication
}
export type BulletinBoardQueryResponseRead = {
  /** Unique identifier for the bulletin. */
  id?: string | null
  /** Identifier for the client to which the bulletin belongs. */
  clientId?: string | null
  activePeriod?: PeriodModel
  event?: EventModel
  /** The date and time when the bulletin was last updated, or null if never updated. */
  updatedDate?: string | null
  status?: BulletinBoardStatus
  /** Indicates whether the bulletin is currently active. */
  isActive?: boolean
  /** Indicates whether the bulletin has been withdrawn. */
  isWithdrawn?: boolean
  /** Indicates whether the bulletin is historic (i.e., its active period has ended). */
  isHistoric?: boolean
  /** The title of the bulletin. */
  title?: string | null
  /** The date and time when the bulletin was created. */
  createdDate?: string
  /** The name identifier of the user who created the bulletin. */
  createdByNameId?: string | null
  /** The display name of the user who created the bulletin. */
  createdBy?: string | null
  /** The name identifier of the user who last updated the bulletin. */
  updatedByNameId?: string | null
  /** The display name of the user who last updated the bulletin. */
  updatedBy?: string | null
  /** The date and time when the bulletin was withdrawn, or null if not withdrawn. */
  withdrawnDate?: string | null
  /** The URL of the image associated with the bulletin. */
  imageUrl?: string | null
  /** True to enable user comments for this bulletin while it is visible on My Page; false to disable comments. */
  areCommentsEnabled?: boolean
  /** Descriptive text of groups selected for alert/notifications for the bulletin.
    Returns "Ikke valgt" if no group is selected, "Alle" if all groups are selected, or the count of selected groups. */
  alertGroups?: string | null
  /** The number of comments on the bulletin. */
  commentsCount?: number
  /** Indicates if the bulletin has been pinned for display at the top of the list. */
  pinned?: number
  publishedByApplication?: BulletinPublishedByApplication
}
export type BulletinBoardQueryResult = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: BulletinBoardQueryResponse[] | null
}
export type BulletinBoardQueryResultRead = {
  /** Total number of items in the entire result */
  totalCount?: number
  /** Total number of result "pages" */
  totalPageCount?: number
  /** Number of items in this "page result" */
  resultCount?: number
  /** If more pages */
  morePages?: boolean
  /** Current page number */
  currentPage?: number
  /** The items */
  result?: BulletinBoardQueryResponseRead[] | null
}
export type BulletinBoardQueryRequestModel = {
  /** The client id (forvaltningsklient-id). */
  clientId?: string | null
  /** Query text to search for in bulletins. */
  searchText?: string | null
  status?: BulletinBoardSearchStatus
  sortColumn?: BulletinBoardQuerySortColumn
  sortOrder?: SortOrder
  /** Number of records to return. Default is 10. If set to -1 for both Take and Skip, paging is not done. */
  take?: number
  /** Number of records to skip. Default is 0. If set to -1 for both Take and Skip, paging is not done. */
  skip?: number
}
export type BulletinBoardNewRequest = {
  /** The title of the bulletin. */
  title?: string | null
  activePeriod?: PeriodModel
  event?: EventModel
  /** The main content or body of the bulletin. */
  content?: string | null
  status?: BulletinBoardStatus
  /** True to enable user comments for this bulletin while it is visible on My Page; false to disable comments. */
  areCommentsEnabled?: boolean
  /** The client id (forvaltningsklient-id) */
  clientId?: string | null
  publishedByApplication?: BulletinPublishedByApplication
}
export type BulletinBoardEmailSettings = {
  status?: BulletinBoardEmailStatus
  /** The name identifier of the user who sent the email. */
  sentByNameId?: string | null
  /** The date and time when the email status was last changed, or null if never changed. */
  dateStatusChanged?: string | null
  /** The date and time when the email was sent, or null if not sent. */
  dateSent?: string | null
  /** Indicates whether the email has been sent. */
  isSent?: boolean
}
export type BulletinBoardDetailsResponse = {
  /** Unique identifier for the bulletin. */
  id?: string | null
  /** Identifier for the client to which the bulletin belongs. */
  clientId?: string | null
  activePeriod?: PeriodModel
  event?: EventModel
  /** The date and time when the bulletin was last updated, or null if never updated. */
  updatedDate?: string | null
  status?: BulletinBoardStatus
  /** Indicates whether the bulletin is currently active. */
  isActive?: boolean
  /** Indicates whether the bulletin has been withdrawn. */
  isWithdrawn?: boolean
  /** Indicates whether the bulletin is historic (i.e., its active period has ended). */
  isHistoric?: boolean
  /** The title of the bulletin. */
  title?: string | null
  /** The date and time when the bulletin was created. */
  createdDate?: string
  /** The name identifier of the user who created the bulletin. */
  createdByNameId?: string | null
  /** The display name of the user who created the bulletin. */
  createdBy?: string | null
  /** The name identifier of the user who last updated the bulletin. */
  updatedByNameId?: string | null
  /** The display name of the user who last updated the bulletin. */
  updatedBy?: string | null
  /** The date and time when the bulletin was withdrawn, or null if not withdrawn. */
  withdrawnDate?: string | null
  /** The URL of the image associated with the bulletin. */
  imageUrl?: string | null
  /** True to enable user comments for this bulletin while it is visible on My Page; false to disable comments. */
  areCommentsEnabled?: boolean
  /** The number of comments on the bulletin. */
  commentsCount?: number
  /** Indicates if the bulletin has been pinned for display at the top of the list. */
  pinned?: number
  publishedByApplication?: BulletinPublishedByApplication
  /** List of attachment metadata associated with the bulletin, including file information and metadata. */
  attachments?: BulletinAttachmentInfoModel[] | null
  emailSettings?: BulletinBoardEmailSettings
  /** The HTML content of the bulletin, overriding the base property to allow inclusion in details responses. */
  html?: string | null
}
export type BulletinBoardDetailsResponseRead = {
  /** Unique identifier for the bulletin. */
  id?: string | null
  /** Identifier for the client to which the bulletin belongs. */
  clientId?: string | null
  activePeriod?: PeriodModel
  event?: EventModel
  /** The date and time when the bulletin was last updated, or null if never updated. */
  updatedDate?: string | null
  status?: BulletinBoardStatus
  /** Indicates whether the bulletin is currently active. */
  isActive?: boolean
  /** Indicates whether the bulletin has been withdrawn. */
  isWithdrawn?: boolean
  /** Indicates whether the bulletin is historic (i.e., its active period has ended). */
  isHistoric?: boolean
  /** The title of the bulletin. */
  title?: string | null
  /** The date and time when the bulletin was created. */
  createdDate?: string
  /** The name identifier of the user who created the bulletin. */
  createdByNameId?: string | null
  /** The display name of the user who created the bulletin. */
  createdBy?: string | null
  /** The name identifier of the user who last updated the bulletin. */
  updatedByNameId?: string | null
  /** The display name of the user who last updated the bulletin. */
  updatedBy?: string | null
  /** The date and time when the bulletin was withdrawn, or null if not withdrawn. */
  withdrawnDate?: string | null
  /** The URL of the image associated with the bulletin. */
  imageUrl?: string | null
  /** True to enable user comments for this bulletin while it is visible on My Page; false to disable comments. */
  areCommentsEnabled?: boolean
  /** Descriptive text of groups selected for alert/notifications for the bulletin.
    Returns "Ikke valgt" if no group is selected, "Alle" if all groups are selected, or the count of selected groups. */
  alertGroups?: string | null
  /** The number of comments on the bulletin. */
  commentsCount?: number
  /** Indicates if the bulletin has been pinned for display at the top of the list. */
  pinned?: number
  publishedByApplication?: BulletinPublishedByApplication
  /** List of attachment metadata associated with the bulletin, including file information and metadata. */
  attachments?: BulletinAttachmentInfoModel[] | null
  emailSettings?: BulletinBoardEmailSettings
  /** The HTML content of the bulletin, overriding the base property to allow inclusion in details responses. */
  html?: string | null
}
export type BulletinBoardUpdateRequest = {
  /** The title of the bulletin. */
  title?: string | null
  activePeriod?: PeriodModel
  event?: EventModel
  /** The main content or body of the bulletin. */
  content?: string | null
  status?: BulletinBoardStatus
  /** True to enable user comments for this bulletin while it is visible on My Page; false to disable comments. */
  areCommentsEnabled?: boolean
}
export type BblErrorModel = {
  /** What went wrong */
  message?: string | null
  /** Stacktrace */
  stackTrace?: string | null
}
export type BulletinBoardReadStatusSummary = {
  /** The unique identifier of the bulletin. */
  bulletinId?: number
  /** The number of users who have read the bulletin. */
  readCount?: number
  /** The number of users who have not read the bulletin. */
  notReadCount?: number
  /** The number of users who have reserved against electronic communication for the bulletin. */
  reservedCount?: number
}
export type UnitIdentification = {
  /** SsbNo
    PropertyUnitNumber (dwelling number) */
  ssbNo?: string | null
  /** The section number of the unit
                <remarks>Seksjonsnummer</remarks> */
  sectionNo?: number | null
  /** The PropertySectionNo number of the unit. ShareNo if belonging to corporation
    <remarks>Andelsnummer (Aksjenummer for akssjeselskap)</remarks> */
  propertySectionNo?: string | null
  /** Enumeration of a unit, must be connected with a client as multiple clients can have the same number. */
  propertyNumber?: number
  /**  Property shared number
    <remarks>Aksjeboenhetsnummer</remarks> */
  propertySharedNo?: string | null
}
export type BulletinBoardUserModel = {
  /** Nameregister id
    <remarks>Navneregisterid</remarks> */
  nameregisterId?: string | null
  /** True if given user is proxy owner
    <remarks>Er fullmaktshaver</remarks> */
  isProxyOwner?: boolean
  /** True if given user is owner
    <remarks>Er eier</remarks> */
  isOwner?: boolean
  /** True if given user is tenant
    <remarks>Er leietaker</remarks> */
  isTenant?: boolean
  /** True if given user is resident
    <remarks>Er medboer</remarks> */
  isCoResident?: boolean
  /** Address of unit
    <remarks>Enhetsaddresse</remarks> */
  address?: string | null
  unitIdentificationFields?: UnitIdentification
  /** If user has reserved against electronic communication - date of reservation
    <remarks>Dato for reservert mot elektronisk kommunikasjon</remarks> */
  reservedAgainstElectronicCommunication?: string | null
  /** True if given user has never signed in to BBLiD
    <remarks>Bruker har ikke logget inn i BBLiD</remarks> */
  hasSignedIn?: boolean
  /** Full name of user
    <remarks>Fullt navn</remarks> */
  name?: string | null
  /** User email address */
  email?: string | null
  /** User mobilenumber */
  mobile?: string | null
  /** Number of emails a user has received about a bulletin. (Not from portalusers ms) */
  emailNotificationCount?: number
}
export type BulletinBoardReadStatusDetails = {
  /** List of users who have read the bulletin. */
  usersRead?: BulletinBoardUserModel[] | null
  /** List of users who have not read the bulletin. */
  usersUnread?: BulletinBoardUserModel[] | null
  /** List of users who have reserved against electronic communication for the bulletin. */
  usersReserved?: BulletinBoardUserModel[] | null
}
export type AlertModelSelection = {
  alertType?: AlertType
  /** The reference identifier related to the alert type (such as an address ID, meter ID, or object ID). */
  alertTypeRefId?: string | null
  /** A description of the alert. */
  description?: string | null
  selected?: boolean
}
export type AlertModel = {
  alertType?: AlertType
  /** The reference identifier related to the alert type (such as an address ID, meter ID, or object ID). */
  alertTypeRefId?: string | null
  /** A description of the alert. */
  description?: string | null
}
export type BulletinBoardPinnedUpdateRequest = {
  /** True if bulletin should be pinned to top of the list, false if not. */
  pinned?: boolean
}
export type CommentInsertModel = {
  /** The comment text. */
  text?: string | null
}
export type CommentPersonModel = {
  /** Example: "Robin" */
  firstName?: string | null
  /** Example: "Hood" */
  surname?: string | null
  /** Example: "styreleder" */
  roleDescription?: string | null
  /** Example: "Robin Hood (styreleder)" */
  fullNameAndRoleDescription?: string | null
  /** NavneregisterId */
  id?: string | null
}
export type CommentModel = {
  /** The comment id. */
  id?: string | null
  /** The comment text. */
  text?: string | null
  createdBy?: CommentPersonModel
  /** When the comment was created. */
  createdDate?: string
  /** When the comment was updated, or null if the comment hasn't been updated. */
  updatedDate?: string | null
  /** When the comment was deleted, or null if the comment hasn't been deleted. */
  deletedDate?: string | null
  /** Id of the bulletin that was commented on. */
  bulletinId?: string | null
  /** True if the logged on user currently can edit or delete the comment. */
  isEditable?: boolean
}
export type CommentModelRead = {
  /** The comment id. */
  id?: string | null
  /** The comment text. */
  text?: string | null
  createdBy?: CommentPersonModel
  /** When the comment was created. */
  createdDate?: string
  /** When the comment was updated, or null if the comment hasn't been updated. */
  updatedDate?: string | null
  /** When the comment was deleted, or null if the comment hasn't been deleted. */
  deletedDate?: string | null
  /** Id of the bulletin that was commented on. */
  bulletinId?: string | null
  /** True if the comment has been edited after it was created. Otherwise false.
    Note: Can be true even if IsDeleted is true. */
  isUpdated?: boolean
  /** True if the comment has been deleted. Otherwise false. */
  isDeleted?: boolean
  /** True if the logged on user currently can edit or delete the comment. */
  isEditable?: boolean
}
export type CommentUpdateModel = {
  /** The changed comment text. */
  text?: string | null
}
export enum BulletinPublishedByApplication {
  BoardPortal = 'BoardPortal',
  MyPage = 'MyPage',
}
export enum BulletinBoardStatus {
  Draft = 'Draft',
  Active = 'Active',
  Withdrawn = 'Withdrawn',
}
export enum BulletinBoardSearchStatus {
  All = 'All',
  Active = 'Active',
  Draft = 'Draft',
  Historic = 'Historic',
}
export enum BulletinBoardQuerySortColumn {
  FromDate = 'FromDate',
  ToDate = 'ToDate',
  CreatedBy = 'CreatedBy',
  WithdrawnDate = 'WithdrawnDate',
  Title = 'Title',
  UpdatedDate = 'UpdatedDate',
  Pinned = 'Pinned',
}
export enum SortOrder {
  Ascending = 'Ascending',
  Descending = 'Descending',
}
export enum BulletinBoardEmailStatus {
  DoNotSend = 'DoNotSend',
  Send = 'Send',
  Sent = 'Sent',
}
export enum AlertType {
  Address = 'Address',
  Meter = 'Meter',
  Object = 'Object',
  All = 'All',
}
export const {
  useGetBulletinsQuery,
  useGetBulletinsByBulletinIdQuery,
  usePutBulletinsByBulletinIdSetreadMutation,
  usePutBulletinsByBulletinIdSetunreadMutation,
  useGetBulletinsByBulletinIdAttachmentsAndAttachmentIdQuery,
  useGetBulletinsByBulletinIdEventQuery,
  usePostMaintenanceBulletinsListQuery,
  usePostMaintenanceBulletinsMutation,
  useGetMaintenanceBulletinsByBulletinIdQuery,
  usePutMaintenanceBulletinsByBulletinIdMutation,
  useDeleteMaintenanceBulletinsByBulletinIdMutation,
  usePostMaintenanceBulletinsByBulletinIdImageMutation,
  useDeleteMaintenanceBulletinsByBulletinIdImageMutation,
  useGetMaintenanceBulletinsByBulletinIdEventQuery,
  useGetMaintenanceBulletinsByBulletinIdReadstatusSummaryQuery,
  useGetMaintenanceBulletinsByBulletinIdReadstatusDetailsQuery,
  useGetMaintenanceBulletinsByBulletinIdAlertsQuery,
  usePostMaintenanceBulletinsByBulletinIdAlertsMutation,
  useDeleteMaintenanceBulletinsByBulletinIdAlertsMutation,
  usePostMaintenanceBulletinsByBulletinIdAttachmentsMutation,
  useGetMaintenanceAttachmentsByAttachmentIdQuery,
  useDeleteMaintenanceAttachmentsByAttachmentIdMutation,
  useGetMaintenanceAlertsQuery,
  usePostMaintenanceByBulletinIdNotificationsResendMutation,
  usePutMaintenanceByBulletinIdPinnedMutation,
  usePostBulletinsByBulletinIdCommentsMutation,
  useGetBulletinsByBulletinIdCommentsQuery,
  usePutBulletinsByBulletinIdCommentsAndCommentIdMutation,
  useDeleteBulletinsByBulletinIdCommentsAndCommentIdMutation,
  usePostMaintenanceBulletinsByBulletinIdAttachmentsboardarchiveMutation,
} = injectedRtkApi
